import { Navigate } from "react-router-dom";
import useGlobalState from "../Context";

const UnauthorizeAuth = ({ children }) => {
  const [reduxStore] = useGlobalState();

  const logoutUserId = reduxStore?.logoutUserId;

  if (logoutUserId && logoutUserId !== "") {
    return <>{children}</>;
  } else {
    return <Navigate to="/" replace />;
  }
};

export default UnauthorizeAuth;
